import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginRequest } from '../auth/authConfig';
import { useMsal } from "@azure/msal-react";
import logo from '../assets/logo.png';
import '../styles/shared.css';
import '../styles/welcome.css';

function Welcome() {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const isAuthenticated = accounts.length > 0;

  const handleLogin = async () => {
    try {
      await instance.loginRedirect();
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="container">
      <nav className="nav">
        <img src={logo} alt="ExcelEA Logo" className="logo" />
      </nav>
      
      <div className="content welcome-container">
        <h1 className="welcome-title">Welcome to ExcelEA</h1>
        <p className="welcome-subtitle">
          AI-powered enterprise architecture design and documentation
        </p>
        <button 
          onClick={handleLogin} 
          className="button button-primary login-button"
        >
          Sign in to Get Started
        </button>

        <div className="features-grid">
          {/* Your feature cards here */}
        </div>
      </div>
    </div>
  );
}

export default Welcome; 